import React from 'react';
import { Link } from 'react-router-dom';
import { createTableColumn, TableColumnDefinition } from '@fluentui/react-components';
import { Role } from '../../utils/statApi/RolesApi';

const getColumns = (): TableColumnDefinition<Role>[] => {
  return [
    createTableColumn<Role>({
      columnId: 'name',
      renderHeaderCell: () => <h4>Name</h4>,
      renderCell: (item) => <Link to={`/role-description/roles/${item.id}`}>{item.name}</Link>,
    }),
    createTableColumn<Role>({
      columnId: 'description',
      renderHeaderCell: () => <h4>Description</h4>,
      renderCell: (item) => item.description,
    }),
  ];
};

export default getColumns;
